// extracted by mini-css-extract-plugin
export default {"container":"footer_container__QbKC-","inner":"footer_inner__+4Vr5","brand":"footer_brand__vIj7H","logo":"footer_logo__ke--D","nav":"footer_nav__HMWvI","copy":"footer_copy__B61Bp"};